import { ConfirmDialog, LinearProgress, Typography } from '@occc-app/design-system';

export type UnarchiveWalletConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  walletName: string;
};

export const UnarchiveWalletConfirmDialog: React.FC<UnarchiveWalletConfirmDialogProps> = ({
  onClose,
  onConfirm,
  loading,
  walletName,
}) => {
  return (
    <ConfirmDialog
      dialogTitle='Unarchive Wallet'
      onClose={onClose}
      open
      maxWidth='xs'
      confirmButtonText='Unarchive'
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: loading,
      }}
    >
      {loading && <LinearProgress />}
      <Typography>
        {`Are you sure you would like to unarchive "${walletName}" from your program?`}
      </Typography>
    </ConfirmDialog>
  );
};
